<template>
  <div>
    <b-table
      :ref="tableRef"
      :striped="config.isStriped"
      :hoverable="config.isHoverable"
      :debounce-search="config.searchDebounce"
      :aria-next-label="config.nextLabel()"
      :aria-previous-label="config.previousLabel()"
      :aria-page-label="config.pageLabel()"
      :aria-current-label="config.currentPageLabel()"
      :per-page="config.perPage"
      :sticky-header="config.stickyHeader"
      :current-page="currentPagedSortedParameter.pageNumber"
      :pagination-position="config.paginationPosition"
      backend-pagination
      :sort-icon="config.sortIcon"
      :sort-icon-size="config.sortIconSize"
      backend-sorting
      sort-multiple
      :sort-multiple-data="buefySortingPriority"
      :total="total"
      :data="projets"
      :class="{ filtered: activeFilters.length }"
      class="mt-5 contact-table history-table"
      :loading="isLoading"
      @sort="onSort"
      @sorting-priority-removed="sortingPriorityRemoved"
      @page-change="onPageChange"
    >
      <b-table-column
        v-for="column in columns"
        :key="column.field"
        v-bind="column"
        :visible="column.visible"
      >
        <template #default="props">
          <div v-if="column.field === 'action'" class="columns">
            <div
              v-if="
                props.row['statut'] === 'BROUILLON' &&
                new Date(props.row['anneeScolaireDebut']) < new Date() &&
                new Date(props.row['anneeScolaireFin']) > new Date()
              "
              class="columns pb-0"
            >
              <b-button type="is-primary btn-fix" @click="getLink($event, props.row)">
                {{ $t("projet.historique.complete") }}
              </b-button>
            </div>
            <div v-else class="columns pb-0">
              <b-button type="is-info is-outlined btn-fix" @click="getLink($event, props.row)">
                {{ $t("projet.historique.consulter") }}
              </b-button>
            </div>
          </div>
          <div
            v-if="column.field === 'statut'"
            class="columns clickable"
            @click="showDetailsPage($event, props.row)"
          >
            <div class="column pb-0">
              <span
                v-if="
                  props.row['statut'] === 'BROUILLON' &&
                  new Date(props.row['anneeScolaireDebut']) < new Date() &&
                  new Date(props.row['anneeScolaireFin']) > new Date()
                "
              ></span>
              <span
                v-if="
                  props.row['statut'] === 'BROUILLON' &&
                  new Date(props.row['anneeScolaireDebut']) < new Date() &&
                  new Date(props.row['anneeScolaireFin']) < new Date()
                "
                >{{ $t("projet.historique.no-label") }}</span
              >
              <span
                v-if="
                  props.row['statut'] === 'REFUSE' &&
                  props.row['typeDossier'] === 'DOSSIER_LABELLISATION'
                "
                >{{ $t("projet.historique.refus") }}</span
              >
              <span
                v-if="
                  props.row['statut'] === 'REFUSE' &&
                  props.row['typeDossier'] === 'DOSSIER_INSCRIPTION'
                "
                >{{ $t("projet.historique.refus_inscription") }}</span
              >
              <span
                v-if="
                  props.row['typeDossier'] === 'DOSSIER_INSCRIPTION' &&
                  (props.row['statut'] === 'ACCEPTE' ||
                    props.row['statut'] === 'ACCEPTE_SOUS_RESERVE_REFERENT')
                "
                >{{ $t("projet.historique.inscription") }}</span
              >
              <span
                v-if="
                  props.row['typeDossier'] === 'DOSSIER_LABELLISATION' &&
                  (props.row['statut'] === 'ACCEPTE' ||
                    props.row['statut'] === 'LABELLISATION_EN_DEVENIR')
                "
                >{{ $t("projet.historique.label") }}</span
              >
              <span
                v-if="
                  (props.row['typeDossier'] === 'DOSSIER_RENOUVELLEMENT' ||
                    props.row['typeDossier'] === 'DOSSIER_RENOUVELLEMENT_LIGHT') &&
                  props.row['statut'] === 'ACCEPTE'
                "
                >{{ $t("projet.historique.renouvelle") }}</span
              >
            </div>
          </div>

          <div
            v-if="column.field === 'classes'"
            class="columns clickable"
            @click="showDetailsPage($event, props.row)"
          >
            <div
              v-for="classe in props.row['classes'].filter((o: any) => o && o.id)"
              :key="props.row['id'] + '_' + classe.id"
              class="column pb-0 classe"
            >
              <span v-if="classe.eleves_cp">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.CP")
              }}</span>
              <span v-if="classe.eleves_ce1">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.CE1")
              }}</span>
              <span v-if="classe.eleves_ce2">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.CE2")
              }}</span>
              <span v-if="classe.eleves_cm1">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.CM1")
              }}</span>
              <span v-if="classe.eleves_cm2">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.CM2")
              }}</span>
              <span v-if="classe.eleves_6eme">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.6E")
              }}</span>
              <span v-if="classe.eleves_5eme">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.5E")
              }}</span>
              <span v-if="classe.eleves_4eme">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.4E")
              }}</span>
              <span v-if="classe.eleves_3eme">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.3E")
              }}</span>
              <span v-if="classe.eleves_2nde">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.2ND")
              }}</span>
              <span v-if="classe.eleves_1ere">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.1E")
              }}</span>
              <span v-if="classe.eleves_terminale">{{
                $t("projetPage.infoAdministratives.classe.niveauxLabels.TERMINALE")
              }}</span>
              <span v-if="classe.autre1">{{ classe.autre1 }}</span>
              <span v-if="classe.autre2">{{ classe.autre2 }}</span>
            </div>
            <div v-if="props.row['classes'].length === 0" class="column pb-0">
              {{ $t("projet.historique.no-class") }}
            </div>
          </div>

          <div v-if="column.field === 'pitch'" class="columns">
            <div v-if="props.row['pitch']" class="column pb-0">
              <b-button type="is-outlined" @click="openPitchDialog($event, props.row)">
                <b-icon icon="eye" size="is-small" type="is-dark"></b-icon>
              </b-button>
            </div>
            <div v-else class="column pb-0">{{ $t("projet.historique.no-pitch") }}</div>
          </div>

          <div v-if="column.field === 'referents'" class="columns">
            <div
              v-for="referent in props.row['referents'].filter((o: any) => o && o.id && o.nom)"
              :key="props.row['id'] + '_' + referent.id"
              class="column pb-0"
            >
              {{ referent.prenom + " " + referent.nom }}
            </div>
          </div>

          <div
            v-if="column.field === 'structures'"
            class="columns clickable"
            @click="showDetailsPage($event, props.row)"
          >
            <div
              v-for="structure in props.row['structures'].filter((o: any) => o && o.id && o.nom)"
              :key="props.row['id'] + '_' + structure.id"
              class="column pb-0"
            >
              {{ structure.nom }}
            </div>
          </div>

          <div
            v-if="column.field === 'echanges'"
            class="columns clickable"
            @click="showDetailsPage($event, props.row)"
          >
            <div class="column pb-0">
              <b-button
                v-if="
                  commentaires.filter(
                    (o: any) =>
                      o.dateCreation < props.row['anneeScolaireFin'] &&
                      o.dateCreation > props.row['anneeScolaireDebut'],
                  ).length > 0
                "
                type="is-outlined"
                @click="openCommentairesDialog($event, props.row)"
                >{{ $t("projet.historique.consulter") }}
              </b-button>
              <span v-else>{{ $t("projet.historique.no-comment") }}</span>
            </div>
          </div>
          <div v-if="!column.custom" class="clickable" @click="showDetailsPage($event, props.row)">
            <div>{{ $t(props.row[column.field]) }}</div>
          </div>
        </template>
      </b-table-column>

      <template #empty>
        <div class="empty-table">
          {{ $t("instruction-panel.contacts.aucun-contact") }}
        </div>
      </template>
    </b-table>
    <PitchModale
      :pitch="selectedPitch"
      :open="openPitchModale"
      @close-modale="openPitchModale = false"
    />
    <CommentairesModale
      :commentaires="selectedCommentaires"
      :open="openCommentairesModale"
      @close-modale="openCommentairesModale = false"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import {
  CommentaireDTO,
  FilterDTO,
  PaginationOrder,
  PaginationParameter,
  ProjetAnnuelDTO,
  ProjetAnnuelForInstructionDTO,
} from "@/model/bean/GeneratedDTOs"
import Column from "@/views/tables/Column"
import { ProjectService } from "@/services/rest/project/ProjectService"
import PitchModale from "./PitchModaleView.vue"
import CommentairesModale from "./CommentairesModaleView.vue"
import { CommentaireService } from "@/services/rest/commentaire/CommentaireService"
import { useTableView } from "@/hooks/useTableView"
import { SortOrder } from "@/model/SortOrder"
import { BButton, BIcon, BTable, BTableColumn } from "buefy"

export default defineComponent({
  name: "ProjetHistoryView",
  components: {
    PitchModale,
    CommentairesModale,
    BButton,
    BIcon,
    BTable,
    BTableColumn,
  },
  props: {
    projetAnnuel: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    isPorteurProjet: {
      type: Boolean,
      default: false,
    },
    role: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      projectService: ProjectService.INSTANCE,
      commentaireService: CommentaireService.INSTANCE,
      projets: [] as Array<ProjetAnnuelForInstructionDTO>,
      commentaires: [] as Array<CommentaireDTO>,
      openPitchModale: false,
      selectedPitch: "",
      openCommentairesModale: false,
      selectedCommentaires: [] as Array<CommentaireDTO>,
      // Hook sera initialisé dans created()
      tableView: null as any,
    }
  },
  computed: {
    // Propriétés réactives exposées par le hook
    columns(): Array<Column> {
      return this.tableView?.state.columns || []
    },
    isLoading(): boolean {
      return this.tableView?.state.isLoading || false
    },
    currentPagedSortedParameter(): PaginationParameter {
      return this.tableView?.state.currentPagedSortedParameter
    },
    activeFilters(): Array<FilterDTO> {
      return this.tableView?.state.activeFilters || []
    },
    buefySortingPriority(): Array<any> {
      return this.tableView?.state.buefySortingPriority || []
    },
    total(): number {
      return this.tableView?.state.total || 0
    },
    config(): any {
      return this.tableView?.state.config
    },
    tableRef(): string {
      return this.tableView?.state.tableRef || "tableProjetHistory"
    },
  },
  created() {
    // Initialisation du hook avec binding correct
    this.tableView = useTableView({
      router: this.$router,
      route: this.$route,
      i18n: this.$i18n,
      tableRef: "tableProjetHistory",
      getInitialColumns: this.getInitialColumns.bind(this),
      getDefaultSort: this.getDefaultSort.bind(this),
      getInitialActiveFilters: this.getInitialActiveFilters.bind(this),
      reloadData: this.reloadData.bind(this),
      reloadDataWhenMounted: false,
    })

    if (this.projetAnnuel.projetId) {
      this.loadHistory()
      this.loadCommentaires()
    }
  },
  methods: {
    // Méthodes déléguées au hook
    onPageChange(page: string | number): void {
      const pageNum = typeof page === "string" ? parseInt(page) : page
      this.tableView?.onPageChange(pageNum)
    },

    onSort(field: string | undefined, order: SortOrder): void {
      if (field) {
        this.tableView?.onSort(field, order)
      }
    },

    sortingPriorityRemoved(field: string | undefined): void {
      if (field) {
        this.tableView?.sortingPriorityRemoved(field)
      }
    },

    updateTotal(total: number): void {
      this.tableView?.updateTotal(total)
    },

    // Méthodes callbacks requises par le hook
    getInitialActiveFilters(): Array<FilterDTO> {
      return new Array<FilterDTO>()
    },

    getDefaultSort(): Array<PaginationOrder> {
      return new Array<PaginationOrder>()
    },

    async reloadData(): Promise<void> {
      // Cette classe n'utilise pas vraiment reloadData pour charger les données
      // car elle charge les projets dans loadHistory
      return Promise.resolve()
    },

    async loadHistory(): Promise<void> {
      if (this.tableView) {
        this.tableView.state.isLoading = true
      }
      this.projets = await this.projectService.getProjectHistory(this.projetAnnuel.projetId)
      this.updateTotal(this.projets.length)
      if (this.tableView) {
        this.tableView.state.isLoading = false
      }
    },

    async loadCommentaires(): Promise<void> {
      this.commentaires = await this.commentaireService.getCommentaires(this.projetAnnuel.projetId)
    },

    getInitialColumns(): Array<Column> {
      const columns = [
        {
          field: "anneeScolaire",
          label: this.$t("projet.historique.annee-scolaire").toString(),
          sortable: false,
          backEndSearchable: false,
          visible: true,
          custom: false,
          canBeAdded: false,
        },
        {
          field: "action",
          label: " ",
          sortable: false,
          backEndSearchable: false,
          visible: true,
          custom: true,
          canBeAdded: false,
        },
        {
          field: "statut",
          label: this.$t("projet.historique.statut").toString(),
          sortable: false,
          backEndSearchable: false,
          visible: true,
          custom: true,
          canBeAdded: false,
        },
        {
          field: "etat",
          label: this.$t("projet.historique.etat").toString(),
          sortable: false,
          backEndSearchable: false,
          visible: true,
          custom: false,
          canBeAdded: false,
        },
        {
          field: "classes",
          label: this.$t("projet.historique.classes").toString(),
          sortable: false,
          backEndSearchable: false,
          visible: true,
          custom: true,
          canBeAdded: false,
        },
        {
          field: "pitch",
          label: this.$t("projet.historique.pitch").toString(),
          sortable: false,
          backEndSearchable: false,
          visible: true,
          custom: true,
          canBeAdded: false,
        },
      ]
      if (!this.isPorteurProjet || this.role == "SUPER_ADMINISTRATEUR") {
        columns.push(
          {
            field: "referents",
            label: this.$t("projet.historique.referents").toString(),
            sortable: false,
            backEndSearchable: false,
            visible: true,
            custom: true,
            canBeAdded: false,
          },
          {
            field: "structures",
            label: this.$t("projet.historique.structures").toString(),
            sortable: false,
            backEndSearchable: false,
            visible: true,
            custom: true,
            canBeAdded: false,
          },
          {
            field: "echanges",
            label: this.$t("projet.historique.echanges").toString(),
            sortable: false,
            backEndSearchable: false,
            visible: true,
            custom: true,
            canBeAdded: false,
          },
        )
      }

      return columns
    },

    openPitchDialog(event: Event, projetAnnuel: ProjetAnnuelDTO): void {
      // Do not foward click event to row (would trigger modal)
      event.stopPropagation()
      this.selectedPitch = projetAnnuel.pitch
      this.openPitchModale = true
    },

    openCommentairesDialog(event: Event, projetAnnuel: ProjetAnnuelForInstructionDTO): void {
      // Do not foward click event to row (would trigger modal)
      event.stopPropagation()
      this.selectedCommentaires = this.commentaires.filter(
        (o: any) =>
          o.dateCreation < projetAnnuel.anneeScolaireFin &&
          o.dateCreation > projetAnnuel.anneeScolaireDebut,
      )
      this.openCommentairesModale = true
    },

    getLink(event: Event, projet: ProjetAnnuelDTO): void {
      event.stopPropagation()
      if (projet.typeDossier === "DOSSIER_INSCRIPTION") {
        this.$router.push("/project/" + projet.projetId + "/" + projet.id + "/inscription/0")
      } else {
        this.$router.push("/project/" + projet.projetId + "/" + projet.id + "/bref/0")
      }
    },

    showDetailsPage(event: Event, projet: ProjetAnnuelDTO): void {
      // Do not forward click event to row (would trigger modal)
      event.stopPropagation()
      if (projet.typeDossier === "DOSSIER_INSCRIPTION") {
        this.$router.push("/project/" + projet.projetId + "/" + projet.id + "/inscription/0")
      } else {
        this.$router.push("/project/" + projet.projetId + "/" + projet.id + "/bref/0")
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.btn-fix {
  position: relative;
  top: 25px;
  right: 0;
  margin-right: 10px;
  height: 100%;
}

.columns {
  flex-direction: column;
  margin-bottom: 10px;
  padding-bottom: 10px;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.classe {
  :not(:last-child)::after {
    content: " - ";
  }
}

.history-table {
  overflow: hidden;
}
</style>
